<template>
  <div>
    <div style="margin-bottom:15px;">
      <span class="common-title">基础资产</span>
      <span
        class="text-color-blue pointer right-oper"
        @click="showMore = !showMore"
      >
        {{ showMore ? "收起" : "展开" }}
        <a-icon :type="showMore ? 'up' : 'down'" style="font-size:12px" />
      </span>
    </div>
    <table class="table-common">
      <thead>
        <tr>
          <th>单据类型</th>
          <th>单据编号</th>
          <th>应付金额（元）</th>
          <th>起始日期</th>
          <th>合同编号</th>
          <th>相关凭证</th>
          <th>
            <span v-if="getBuyOrSell == 'buyer'">卖方名称</span>
            <span v-else>买方名称</span>
          </th>
          <th>祺信金额（元）</th>
        </tr>
      </thead>
      <tbody v-if="showMore">
        <tr v-for="(item, index) in pageData" :key="index">
          <td>{{ item.docTpCd | docIdFilter }}</td>
          <td>
            <a
              @click="invoiceInfoOpen(item)"
              v-if="goldData.firstGldId == gldId"
              >{{ item.docId || item.invoiceNumber }}</a
            >
            <span v-else>{{ item.docId || item.invoiceNumber }}</span>
          </td>
          <td>{{ item.rcvbAmt | splitK }}</td>
          <td>{{ item.rcvbStDt | dateFormat("YYYY-mm-dd") }}</td>
          <td>
            <a
              @click="contractInfoOpen(item)"
              v-if="goldData.firstGldId == gldId"
              >{{ item.trdCtrId }}</a
            >
            <span v-else>{{ item.trdCtrId }}</span>
          </td>
          <td>
            <a
              @click="voucherInfoOpen(item)"
              v-if="goldData.firstGldId == gldId"
              >{{ voucherList(item.voucherList)  }}</a
            >
            <span v-else>{{ voucherList(item.voucherList) }}</span>
          </td>
          <td>
            <span v-if="getBuyOrSell == 'buyer'">{{ item.cstIdNm }}</span>
            <span v-else>{{ item.cntprIdNm }}</span>
          </td>
          <td>{{ item.estbAmt | splitK }}</td>
        </tr>
        <tr v-if="pageData.length == 0">
          <td colspan="8" style="text-align: center;">暂无数据</td>
        </tr>
      </tbody>
      <tbody v-if="!showMore">
        <tr>
          <td colspan="8" style="text-align: center;color:#999;font-size:18px;">
            ···
          </td>
        </tr>
      </tbody>
    </table>
    <!-- 查看合同 -->
    <contractDialog
      title="合同详情"
      ref="contractInfo"
      :readonly="true"
      :info.sync="curRow"
    />
    <!-- 单据详情 -->
    <invoiceInfo ref="invoiceInfo" :readonly="true" :info.sync="curRow" />
    <!-- 相关凭证 -->
    <deliveryVoucherDialog ref="deliveryVoucherDialog" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { queryDocumInformation } from "@/api/gold.js";
import contractDialog from "@/pages/bill-manage/payable/contract-info-dialog";
import invoiceInfo from "@/pages/bill-manage/payable/invoice-info-dialog";
import deliveryVoucherDialog from "@/pages/bill-manage/payable/delivery-voucher-dialog";
export default {
  props: {
    // 祺信id
    goldIdParam: {
      type: String,
      default() {
        return undefined;
      }
    },
    // 祺信详情数据
    goldData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  name: "gold-detail-origin-info",
  data() {
    return {
      pageData: [],
      showMore: false,
      curRow: null
    };
  },
  components: {
    contractDialog,
    invoiceInfo,
    deliveryVoucherDialog
  },
  computed: {
    way() {
      if (this.parentData) {
        return this.parentData.way;
      }
      return this.$route.params.way;
    },
    gldId() {
      if (this.parentData && this.parentData.way == "rcvb") {
        return this.parentData.goldObj.oriGldId;
      } else if (this.parentData) {
        return this.parentData.gldId;
      } else if (this.goldIdParam) {
        return this.goldIdParam;
      }
      return this.$route.params.gldId;
    },
    gldStCds() {
      const fromType = this.parentData
        ? this.parentData.fromType
        : this.$route.params.fromType;
      switch (fromType) {
        case "3":
          return "0,1,5,6,7";
        case "5":
          return "";
        default:
          return "";
      }
    },
    ...mapGetters({
      getBuyOrSell: "app/getBuyOrSell",
      parentData: "app/getGoldDetailPrarms"
    })
  },
  created() {
    this.queryDocumInformation();
  },
  mounted() {},
  methods: {
    queryDocumInformation() {
      if (!this.gldId) {
        return;
      }
      let param = {
        gldId: this.gldId,
        way: this.parentData && this.parentData.way
      };
      queryDocumInformation(param)
        .then(res => {
          this.pageData = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    contractInfoOpen(data) {
      data.contractNo = data.trdCtrId;
      this.curRow = {...data,sellrOrgCode:data.sellrCrCd,buyrOrgCode:data.buyrCrCd};
      this.$refs.contractInfo.open();
    },
    invoiceInfoOpen(data) {
      this.curRow = data;
      this.$refs.invoiceInfo.open();
    },
    voucherList(arr){
      console.log("%c Line:192 🥥 arr", "color:#42b983", arr);
      if(arr.length>0){
        let str = arr.map((item)=>{
          return item.file.fileNm;
        }).join(",");
        return str

      }else{
        return "-";
      }
    },
    // 相关凭证上传、编辑、查看
    voucherInfoOpen(record) {
      this.$refs.deliveryVoucherDialog.open({
        invData: record,
        voucherList: record.voucherList,
        dialogType: "detail"
      });
    }
  },
  watch: {
    gldId(newVal) {
      this.queryDocumInformation();
    }
  },
  activated() {}
};
</script>
<style scoped>
.right-oper {
  float: right;
  margin: 0 10px 10px 0;
}
.table-common {
  width: 100%;
}
.table-common th {
  background: #f5f9fb;
  color: #1b1d1f;
}
.table-common th,
.table-common td {
  padding: 10px 10px;
  text-align: center;
  color: #1b1d1f;
}
.table-common td {
  font-size: 12px;
  background: #ffffff;
  border-bottom: 5px solid #f5f9fb;
}
.table-common tbody tr:nth-child(2n) {
  background: #f5f7f9;
}
</style>



// WEBPACK FOOTER //
// src/components/gold-page/gold-detail-origin-info.vue